var _circle, _path, _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsewaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 76,
    viewBox: "0 0 260 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eSewa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 32,
    fill: "#60BB46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 41H26.2C27.2 48.1 32.1 52.2 39.2 52.2C44.2 52.2 48 50.5 51.3 47.2L56.4 53C52.1 57.8 46.2 60.2 38.8 60.2C25.6 60.2 17 51.7 17 38.6C17 25.7 25.7 17 38 17C50 17 58 25.1 58 38.4C58 39.2 57.8 40.2 57.7 41H55.5ZM26.1 34.5H48.8C48 27.9 43.9 23.8 38 23.8C32.1 23.8 27.1 28 26.1 34.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 33.5,
    width: 16,
    height: 8,
    rx: 1.5,
    fill: "#60BB46"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 54,
    fill: "#202033",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 48,
    fontWeight: 700
  }, "Sewa")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsewaLogo);
export default __webpack_public_path__ + "static/media/esewa-logo.84def975fd9dc101f874fbdfcb40cc6c.svg";
export { ForwardRef as ReactComponent };